import React, { useRef } from "react";
import { Box, Button, Grid } from "@mui/material";
import HazardMap from "../../assets/hazard_map_MAR.jpg";
import { PDFExport } from "@progress/kendo-react-pdf";
import html2canvas from "html2canvas";
import moment from "moment";

const HazardMapping = () => {
  const pdfExportComponent = useRef(null);
  const exportContentRef = useRef(null);

  const downloadAsImage = () => {
    if (exportContentRef.current) {
      html2canvas(exportContentRef.current, { scale: 2 })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imgData;
          link.download = `hazard-map-${moment().format("YYYY-MM-DD_HH-mm-ss")}.png`;
          link.click();
        })
        .catch((error) => {
          console.error("Error capturing image:", error);
        });
    }
  };

  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <PDFExport
        paperSize="auto"
        margin="1cm"
        ref={pdfExportComponent}
        fileName={`hazard-map-${moment().format("YYYY-MM-DD_HH-mm-ss")}`}
      >
        <div ref={exportContentRef}>
          <img
            src={HazardMap}
            alt="Hazard Map"
            style={{
              display: "block",
              margin: "0 auto",
              maxWidth: "100%",
              height: "auto",  
            }}
          />
        </div>
      </PDFExport>

      <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (pdfExportComponent.current) {
                pdfExportComponent.current.save();
              }
            }}
          >
            Download as PDF
          </Button>

        </Grid>
        <Grid item>
          <Button 
          variant="contained" 
          color="primary"
          onClick={downloadAsImage}>
            Download as Image
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HazardMapping;

